import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserApiService from '../services/UserApiService';

/**
 * Profile page component
 */
const Profile = () => {
  const { userProfile, userRoles } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [apiUserInfo, setApiUserInfo] = useState(null);

  // Get user info from API
  useEffect(() => {
    const fetchUserInfo = async () => {
      setLoading(true);
      try {
        const userInfo = await UserApiService.getUserInfo();
        setApiUserInfo(userInfo);
        setError(null);
      } catch (err) {
        console.error('Error fetching user info:', err);
        setError('Failed to fetch user information from API');
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  // Get user's first initial for avatar
  const getInitial = () => {
    const firstName = userProfile?.firstName || userProfile?.given_name || '';
    return firstName.charAt(0).toUpperCase();
  };

  if (!userProfile) {
    return (
      <div className="page-container">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Profile</h2>
          </div>
          <p>Loading profile information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Your Profile</h2>
        </div>

        <div className="profile-header">
          <div className="profile-avatar">{getInitial()}</div>
          <div className="profile-info">
            <h2>
              {userProfile.firstName || userProfile.given_name} {userProfile.lastName || userProfile.family_name}
            </h2>
            <p className="profile-email">{userProfile.email}</p>
            <div className="profile-roles">
              {userRoles.map((role) => (
                <span key={role} className="role-badge">
                  {role}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="card" style={{ boxShadow: 'none', padding: 0 }}>
          <div className="card-header">
            <h3 className="card-title">Account Information</h3>
          </div>
          <table className="table">
            <tbody>
              <tr>
                <td><strong>Username</strong></td>
                <td>{userProfile.username || userProfile.preferred_username}</td>
              </tr>
              <tr>
                <td><strong>Email</strong></td>
                <td>{userProfile.email}</td>
              </tr>
              <tr>
                <td><strong>First Name</strong></td>
                <td>{userProfile.firstName || userProfile.given_name}</td>
              </tr>
              <tr>
                <td><strong>Last Name</strong></td>
                <td>{userProfile.lastName || userProfile.family_name}</td>
              </tr>
              <tr>
                <td><strong>ID</strong></td>
                <td>{userProfile.id || userProfile.sub}</td>
              </tr>
              <tr>
                <td><strong>Email Verified</strong></td>
                <td>{userProfile.emailVerified ? 'Yes' : 'No'}</td>
              </tr>
            </tbody>
          </table>
        </div>


        {loading && (
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        )}

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        {apiUserInfo && (
          <div className="card" style={{ boxShadow: 'none', padding: 0 }}>
            <div className="card-header">
              <h3 className="card-title">API User Information</h3>
            </div>
            <pre style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
              {JSON.stringify(apiUserInfo, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;